export default function (member) {
  member.id = member.guid
  return member
}
